import { render, staticRenderFns } from "./ApproveTypeSetting.vue?vue&type=template&id=8de190ec"
import script from "./ApproveTypeSetting.vue?vue&type=script&lang=js"
export * from "./ApproveTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports